import React from 'react';
import { FacebookIcon, GhostIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
import type { SocialPlatform } from '../../data/social';
export function SocialIcon({
  platform,
  className = 'h-4 w-4'
}: {
  platform: SocialPlatform;
  className?: string;
}) {
  switch (platform) {
    case 'instagram':
      return <InstagramIcon className={className} aria-hidden="true" data-id="element-693" data-mp="1gnqyez8spijy" />;
    case 'facebook':
      return <FacebookIcon className={className} aria-hidden="true" data-id="element-694" data-mp="1llac9y1kztbd" />;
    case 'youtube':
      return <YoutubeIcon className={className} aria-hidden="true" data-id="element-695" data-mp="1pmm66frhn0pd" />;
    case 'linkedin':
      return <LinkedinIcon className={className} aria-hidden="true" data-id="element-696" data-mp="1umgxulj37ubh" />;
    case 'snapchat':
      return <GhostIcon className={className} aria-hidden="true" data-id="element-697" data-mp="1zmczwf885boe" />;
    case 'tiktok':
      return <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-698" data-mp="98vm8ss8gft">
          <path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5" data-id="element-699" data-mp="59n4tu64dwff" />
          <path d="M14 3c.4 2.6 2.2 4.4 5 4.6" data-id="element-700" data-mp="2t63ok4bxcmbh" />
        </svg>;
  }
}